export default class Licenca {
  constructor(
    cpf_cnpj,
    titulo = '',
    usuarios = [],
    conexoes_simultaneas = 1,
    aplicativo = {
      app_key: {
        _id: '',
        descricao: ''
      },
      host: '',
      id_empresa: ''
    },
    data_expiracao = new Date().toISOString().substr(0, 10)
  ) {
    this.cpf_cnpj = cpf_cnpj;
    this.titulo = titulo;
    this.usuarios = usuarios;
    this.conexoes_simultaneas = conexoes_simultaneas;
    this.aplicativo = aplicativo;
    this.data_expiracao = data_expiracao;
  }
}